import React from 'react';
import Button from 'olive-react-myoneui/lib/Button';
import { trophyIcon, MessageQuestionIcon, clockIcon, rightArrowLong, checkCircleComplete } from '../../../constants/icons';

const TestCard = ({
  testStatus,
  date,
  title,
  questions,
  marksScored,
  totalMarks,
  duration,
  totalDuration,
  grade,
  icon
}) => {
  return (
    <>
      <div className={`icon-wrap ${testStatus === 'completed' ? 'completed' : 'notstarted'}`}>{icon}</div>
      <div className="myk__stu-course_test-report">
        <span className="myk__stu-test-time">{date}</span>
        <h3>{title}</h3>
        <ul className="course_test-analytics">
          <li>
            <div className="course_test-metadata">
              <h4>{MessageQuestionIcon} Questions</h4>
              <p><strong>{questions}</strong></p>
            </div>
          </li>
          <li>
            <div className="course_test-metadata">
              <h4>{checkCircleComplete} Marks scored</h4>
              <p><strong>{marksScored}</strong> / {totalMarks}</p>
            </div>
          </li>
          <li>
            <div className="course_test-metadata">
              <h4>{clockIcon} Duration</h4>
              <p><strong>{duration}</strong> / {totalDuration}</p>
            </div>
          </li>
          <li>
            <div className="course_test-metadata">
              <h4>{trophyIcon} Grade</h4>
              <p><strong>{grade}</strong></p>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
};

export default TestCard;
